export var MimeType;
(function (MimeType) {
    MimeType["IMAGE_JPEG"] = "image/jpeg";
    MimeType["IMAGE_GIF"] = "image/gif";
    MimeType["IMAGE_PNG"] = "image/png";
    MimeType["IMAGE_BMP"] = "image/bmp";
    MimeType["IMAGE_TIFF"] = "image/tiff";
    MimeType["VIDEO_MP4"] = "video/mp4";
    MimeType["VIDEO_MPEG"] = "video/mpeg";
    MimeType["VIDEO_AVI"] = "video/x-msvideo";
    MimeType["VIDEO_MOV"] = "video/quicktime";
    MimeType["VIDEO_WMV"] = "video/x-ms-wmv";
    MimeType["AUDIO_MPEG"] = "audio/mpeg";
    MimeType["APPLICATION_PDF"] = "application/pdf";
    MimeType["APPLICATION_MS_EXCEL"] = "application/vnd.ms-excel";
    MimeType["APPLICATION_OPEN_OFFICE_EXCEL"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    MimeType["APPLICATION_MS_WORD"] = "application/msword";
    MimeType["APPLICATION_OPEN_OFFICE_WORD"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    MimeType["APPLICATION_OCTET_STREAM"] = "application/octet-stream";
    MimeType["APPLICATION_ZIP"] = "application/zip";
    MimeType["TEXT_PLAIN"] = "text/plain";
    MimeType["TEXT_CSV"] = "text/csv";
    MimeType["UNKNOWN"] = "unknown";
})(MimeType || (MimeType = {}));
//# sourceMappingURL=MimeType.js.map